import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';


export default {
  name: 'exportcsv',
  components: {
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      email: '',
      isEmailloader : false,
      displayForm:'',
      show: '',
      emailarray:[],
      listEmailData: [],
      projectid: '',
      successMsg:'',
    }
  },

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localusermailid = userdetail.email;
    this.show = false;
  },
  methods: {
    closeSuccessMsg(){
      this.successMsg = false;
      this.displayForm = false;
    },
    resetForm() {
      this.email = '';
      this.emptype = '';
      this.listEmailData = [];
      this.hubid = ''
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.saveUserEmailAccess();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    closeRegistration() {
      this.$router.push('/admindashboard');
    },

    saveUserEmailAccess() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let emailtempArr=[];
      let removespace = this.email.replaceAll(' ','').replaceAll('\n','').trim()
      var lastChar = removespace.slice(-1);
      if (lastChar == ',') {
        removespace = removespace.slice(0, -1);
        emailtempArr = removespace.split(",");
      }
      else{
        emailtempArr = removespace.split(",");
      }
        this.input = ({
          emailids: emailtempArr
        })
      this.show = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'users/exportDataAgainstUserEmail',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(async result => {
          if(result.data.code == 200){
            let csv = 'userid,username\n'
            result.data.userid.forEach((row) => {
                    csv += row.userid+',';
                    csv += row.username+',';
                    csv += "\n";
            });
            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
            anchor.target = '_blank';
            anchor.download = 'userdetails.csv';
            anchor.click();
            this.show = false;
            this.$alertify.success(result.data.msg);
          }else{
            this.show = false;
            this.$alertify.error("No Data Found");
          }
        }, error => {
          this.show = false;
          this.$alertify.error(error.message);
          console.error(error)
        })
    },


    resetemailWiseForm(){
      this.listEmailData = []
      this.emptype = ''
      this.email = ''
    },
    validateUsername($event){
      this.lettersOnly($event);
    },
  
    lettersOnly : function($event){
      let keyCode = ($event.charCode ? $event.charCode : $event.which);
      if ([44,13].includes(keyCode) && $event.keyCode === this.temp) {
        $event.preventDefault();
      }else {
        this.temp = $event.keyCode
      }
    
       if ((keyCode > 43 && keyCode < 91) || (keyCode > 96 && keyCode < 123) && keyCode !== 32){
         return true;
      }else {
        if ($event.which == 44 || keyCode === 13) {
          return true
        }else {
          $event.preventDefault();
        }
      }
    }
  }
}

Validator.extend('verify_emails', {
  getMessage: field => "Invalid User Email.",
  validate: value => {
      var emails = $("#email").val();
      let email=emails.split(/[,]+/);
      let flag=0;
      for (let i = 0; i < email.length; i++) {
        if(email[i]==""){
          flag=1;
        }
      }
      if(flag==1){
        return false;
      }else{
        return true;
      }
  }
});

Validator.extend('max_emails', {
  getMessage: field => "maximum 50 email you can enter",
  validate: value => {
    var emails = $("#email").val();
    let emailarray = emails.split(/[,]+/);
    if (emailarray.length > 50) {
      return false;
    } else {
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/exportcsv/exportcsv.component.js